export default {"src":"/_next/static/media/info.2b4a7f7c.svg","height":20,"width":20};